import * as angular from "angular";
import { MarkerService } from "../components/map/marker.helper";
import { Filter } from "../models/filter.model";
import { OrganisationService } from "../services/organisation.service";

export class UserMapDataProvider {
    private users: Array<any> = [];
    private loadSize: number = 24;
    private mapListUsers: Array<any> = [];
    private searchPromise: any;
    private mapPromise: any;
    private loading: boolean = false;
    private listWidth: number = 3;
    private numLoadedItems: number = 0;
    private filters = new Filter({ search: "" });
    private bounds: any = {};
    private zoom: any = null;
    private markers: Array<any> = [];
    private mapCountInBounds: number | null = null;
    private infiniteItems: any;
    private type: string;

    private organisationService: OrganisationService;
    private markerService: MarkerService;
    private $timeout: any;
    private $http: any;
    private $q: any;
    private modelsUtils: any;

    constructor(
        $q: any,
        $timeout: any,
        $http: any,
        OrganisationService: OrganisationService,
        MarkerService: MarkerService,
        ModelsUtils: any
    ) {
        this.$q = $q;
        this.organisationService = OrganisationService;
        this.markerService = MarkerService;
        this.$timeout = $timeout;
        this.$http = $http;
        this.modelsUtils = ModelsUtils;

        this.infiniteItems = {
            numLoaded_: 0,
            toLoad_: 0,
            loading: false,
            getItemAtIndex: (index: number) => {
                if (
                    index * this.listWidth > this.mapCountInBounds ||
                    !this.bounds ||
                    !Object.keys(this.bounds).length
                ) {
                    return null;
                }
                if (this.mapListUsers[index]) {
                    return this.mapListUsers[index];
                }
                if (!this.infiniteItems.loading) {
                    this.infiniteItems.fetchMoreItems_(index);
                }
                return null;
            },
            getLength: () => {
                return Math.ceil(this.mapCountInBounds / this.listWidth);
            },
            fetchMoreItems_: (index) => {
                this.infiniteItems.loading = true;
                let offsetValue = null;
                this.infiniteItems.toLoad_ = Math.ceil(
                    (this.mapCountInBounds -
                        this.infiniteItems.numLoaded_ * this.listWidth) /
                        this.listWidth
                );

                if (this.mapListUsers && this.mapListUsers.length > 0) {
                    let lastList =
                        this.mapListUsers[this.mapListUsers.length - 1];
                    if (lastList.length) {
                        let lastValue = lastList[lastList.length - 1];
                        offsetValue = lastValue.uid;
                    }
                }

                this.getAllMapListUsers(
                    this.filters,
                    offsetValue,
                    this.bounds
                ).then((users) => {
                    this.infiniteItems.numLoaded_ = users.length;
                    this.infiniteItems.error = false;
                    this.infiniteItems.loading = false;
                }),
                    (response) => {
                        if (response.status != -1) {
                            this.infiniteItems.error = true;
                            this.infiniteItems.loading = false;
                        }
                    };
            },
            reset: () => {
                this.infiniteItems.numLoaded_ = 0;
                this.infiniteItems.toLoad_ = 0;
                this.mapListUsers.splice(0, this.mapListUsers.length);
            },
        };
    }

    setScreenSize(screenSize: string) {
        if (screenSize == "lg") {
            this.listWidth = 3;
        } else if (screenSize == "md") {
            this.listWidth = 2;
        } else {
            this.listWidth = 1;
        }
        this.infiniteItems.reset();
        this.numLoadedItems = 0;
        this.mapListUsers.splice(0, this.mapListUsers.length);
    }

    setFilters(
        newFilters: Filter,
        bounds: Object,
        type: string = "last_location"
    ) {
        this.bounds = bounds;
        this.filters = newFilters;
        this.infiniteItems.reset();
        this.infiniteItems.loading = false;
        this.numLoadedItems = 0;
        this.mapListUsers.splice(0, this.mapListUsers.length);
        this.type = type;
    }

    getAllMapListUsers(
        filter: Object,
        lastValue: any,
        bounds: Object
    ): Promise<any> {
        const deferred = this.$q.defer();

        if (this.searchPromise) {
            this.searchPromise.resolve("user cancelled");
        }
        this.searchPromise = this.$q.defer();

        this.$http({
            url: "/v2/user/all",
            method: "GET",
            params: {
                filter: JSON.stringify(filter),
                last: lastValue,
                bounds: JSON.stringify(this.bounds),
            },
            timeout: this.searchPromise.promise,
        }).then(
            (response: object) => {
                if (response["data"]) {
                    let json = response["data"];
                    let nestedList = [];
                    this.numLoadedItems += json.data.length;
                    for (let i = 0; i < json.data.length; i++) {
                        if (nestedList.length < this.listWidth) {
                            nestedList.push(
                                this.modelsUtils.user(json.data[i])
                            );
                        } else {
                            this.mapListUsers.push(nestedList);
                            nestedList = [this.modelsUtils.user(json.data[i])];
                        }
                    }
                    if (nestedList.length < this.listWidth) {
                        if (this.listWidth - nestedList.length == 2) {
                            nestedList.push({});
                            nestedList.push({});
                        } else {
                            nestedList.push({});
                        }
                    }
                    this.mapListUsers.push(nestedList);
                    deferred.resolve(this.mapListUsers);
                } else {
                    deferred.reject(response);
                }
            },
            (error: any) => deferred.reject(error)
        );
        return deferred.promise;
    }

    getMapMarkers(oid: string | number | null = null): Promise<any> {
        this.infiniteItems.loading = true;
        const deferred = this.$q.defer();
        if (this.mapPromise) {
            this.mapPromise.resolve("user cancelled");
        }
        this.mapPromise = this.$q.defer();

        this.$http({
            url: "/v2/user/map",
            method: "GET",
            params: {
                filter: JSON.stringify(this.filters),
                zoom: this.zoom,
                bounds: JSON.stringify(this.bounds),
                type: this.type,
            },
            timeout: this.mapPromise.promise,
        }).then(
            (response) => {
                let json = response["data"];
                this.mapCountInBounds = json.countInBounds;
                this.markers.splice(0, this.markers.length);

                let zIndex = 500;
                angular.forEach(json.data, (user) => {
                    user = this.modelsUtils.user(user);
                    if (user.size > 1) {
                        this.markers.push(
                            this.markerService.generateClusterMarker(
                                user,
                                user.lat,
                                user.lng
                            )
                        );
                    } else {
                        this.markers.push(
                            this.markerService.generateUserMarker(
                                user,
                                user.lat,
                                user.lng,
                                false,
                                zIndex
                            )
                        );
                    }
                    zIndex++;
                });

                this.infiniteItems.loading = false;
                deferred.resolve(this.markers);
            },
            (error) => {
                deferred.reject(error);
            }
        );
        return deferred.promise;
    }

    reset() {
        this.infiniteItems.reset();
    }
}

angular
    .module("vcDataProvider")
    .service("UserMapDataProvider", UserMapDataProvider);
